import { APIConfig } from 'src/config';
import { CustomerAddress } from 'src/interfaces/new-channel-partner/channelPartner';
import { CustomerGetResponse, CustomerUser } from 'src/interfaces/user/customer';
import axiosClient from '../utils/axios-client';

class UserApi {
  private userManagementApiUrl = APIConfig.userManagementApiUrl;

  // get user details by userName or MobileNumber
  async getUserByUserName(userName: string):
  Promise<{ responseData: CustomerGetResponse, statusCode: number }> {
    try {
      const res = await axiosClient.get(`${this.userManagementApiUrl}users/customer/${userName}`).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // get user details by userName or MobileNumber
  async getUserDetails():
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.get(`${this.userManagementApiUrl}users/getUserDetails`).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async createCustomerProfile(userDetails: CustomerUser):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.post(`${this.userManagementApiUrl}users/customer`, userDetails).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // calls PUT api to update customer profile
  async updateCustomerProfile(userDetails: CustomerUser):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.put(`${this.userManagementApiUrl}users/customer`, userDetails).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async addCustomerAddress(userName: string, address: CustomerAddress):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.post(`${this.userManagementApiUrl}users/profile/${userName}/address`, address).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async isCustomerExists(mobileNumber: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.userManagementApiUrl}users/customer/${mobileNumber}/exists`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // get customers list by name
  async getCustomersListByName(customerName: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.userManagementApiUrl}users/customer/getByName/${encodeURIComponent(customerName)}`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }
}

export const userApi = new UserApi();
